export const enum GatewayStatus {
  Active = 'active',
  Disabled = 'disabled',
  Test = 'test',
  Pilot = 'pilot',
}
